import React, { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Tab,
  Tabs
} from '@material-ui/core';

import ProductDetails from 'components/Products/ProductDetails';
import ProductsTable from 'components/Products/ProductsTable';
import ProductGroupsTable from 'components/Products/ProductGroupsTable';

import { admin } from 'constants/userAccountTypes';

const ProductListResults = (props) => {
  
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({});
  const [tabValue, setTabValue] = useState(0);

  const addProduct = () => {
    setOpen(true);
    setUpdate(false);
    setUpdateInfo({});
  };

  const updateProduct = () => {
    setOpen(true);
    setUpdate(true);
  };

  const cancelAddUpdate = () => {
    setOpen(false);
    setUpdate(false);
    setUpdateInfo({});
    setTabValue(0);
  };

  const createProductDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.product;
    let productNum;
    length < 100 ? 
      productNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : productNum = length
  
    return ("P-" + productNum);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      { open ?
        ( update ?
          <ProductDetails
            update={update}
            productCategories={props.productCategories}
            productCompanies={props.productCompanies}
            cancelAddUpdate={cancelAddUpdate}
            productInfo={updateInfo}
          /> :
          <ProductDetails
            update={update}
            activeUserId={props.activeUserId}
            productCategories={props.productCategories}
            productCompanies={props.productCompanies}
            cancelAddUpdate={cancelAddUpdate}
            productInfo={{
              displayId: createProductDisplayId(),
              name: "",
              category: props.productCategories[0] ? props.productCategories[0].name : "",
              company: props.productCompanies[0] ? props.productCompanies[0].name : "",
              barcode: ""
            }}
          />
        ) :
        ( props.activeUserType === admin ?
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={addProduct}
              >
                Add Product
              </Button>
            </Box>
            <Box
              sx={{
                display: 'flex'
              }}
            >
              <Paper>
                <Tabs
                  value={tabValue}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleTabChange}
                  centered
                >
                  <Tab label="Products" />
                  <Tab label="Product Categories" />
                  <Tab label="Product Brands" />
                </Tabs>
              </Paper>
            </Box>
            { tabValue === 0 ?
              <Box marginTop={1}>
                <ProductsTable
                  activeUserType={props.activeUserType}
                  products={props.products}
                  updateProduct={updateProduct}
                  setUpdateInfo={setUpdateInfo}
                />
              </Box>
            : null }
            { tabValue === 1 ?
              <Box marginTop={1}>
                <ProductGroupsTable
                  elements={props.productCategories}
                  isCategory={true}
                  products={props.products}
                />
              </Box>
            : null }
            { tabValue === 2 ?
              <Box marginTop={1}>
                <ProductGroupsTable
                  elements={props.productCompanies}
                  isCategory={false}
                  products={props.products}
                />
              </Box>
            : null }
          </Box> :
          <Box marginTop={2}>
            <ProductsTable
              activeUserType={props.activeUserType}
              products={props.products}
            />
          </Box>
        )
      }
    </Box>
  )
};

export default ProductListResults;